// SuspenseWrapper.js
import React, { Suspense } from 'react';

export const withSuspense =
   (Component, fallback = <></>) =>
   props =>
      (
         <Suspense fallback={fallback}>
            <Component {...props} />
         </Suspense>
      );
